<ng-container *ngIf="viewModel$ | async as viewModel">

  <div class="legals-buttons is-not-collapsed">

    <p>
      <span class="legals-button" (click)="openPrivacy(viewModel)">{{ 'common-app.__COM_PRIVACY_POLICY' | AsyncLang | async }}</span>
      &nbsp;·&nbsp;
      <span class="legals-button" (click)="openTerms(viewModel)">{{ 'common-app.__COM_TERMS_AND_CONDITIONS' | AsyncLang | async }}</span>
    </p>

  </div>

  <div class="is-flex is-justify-center is-collapsed">

    <app-context-menu top="auto" bottom="0">

      <app-icon role="anchor" class="legals-icon" name="privacy"></app-icon>

      <app-context-menu-item (click)="openPrivacy(viewModel)">

        <app-text
          [text]="'common-app.__COM_PRIVACY_POLICY' | AsyncLang | async">
        </app-text>

      </app-context-menu-item>

      <app-context-menu-item (click)="openTerms(viewModel)">

        <app-text
          [text]="'common-app.__COM_TERMS_AND_CONDITIONS' | AsyncLang | async">
        </app-text>

      </app-context-menu-item>

    </app-context-menu>

  </div>

</ng-container>

<app-modal *ngIf="modalUrl$ | async as url" [display]="true">
  <app-legals-frame [showClose]="true" [frameUrl]="url" (close)="modalUrl.next(null)"></app-legals-frame>
</app-modal>
